import Modal, { ModalConfirmProps } from '@roo/roo/Modal'
import { getCookie } from '@utiljs/cookie'
import { MERCHANT_MALL_MENU_PATH_PREFIX } from '../constants'
import { CSIMSceneEnum } from '../../components/CSIM/types'

import { commonRequest } from '@/common/api'
import { isGroupOrBrandAcct } from '@RootCommon/utils'

import qs from 'qs'
// import { pureRequest } from '../api'

// export const lastIconVersion = () =>
//   new Promise((resolve) => {
//     pureRequest.get('https://iconfont.sankuai.com/openapi/project/903', {}).then(({ data }) => {
//       resolve(data.versions[0])
//     })
//   })

type ExtendedModalConfirmProps = ModalConfirmProps & {
  title?: string
  closable?: boolean
  children?: React.ReactDOM | Element | string
  status?: 'normal' | 'success' | 'info' | 'danger' | 'question'
  size?: 'sm' | 'lg' | 'default'
  cancelText?: string
  confirmText?: string
  showCancelButton?: boolean
  showConfirmButton?: boolean
  backdropClosable?: boolean
}
export const confirm = (props: ExtendedModalConfirmProps) =>
  new Promise((resolve, reject) => {
    Modal.confirm({
      title: '请确认',
      // @ts-ignore
      children: '',
      // status: 'question',
      ...props,
      onConfirm: resolve,
      onCancel: reject,
    })
  })
// 检查列表重复key
export const checkDuplicatedKey = (propName?: string, list?: any[]) => {
  if (!propName || !list) {
    return false
  }
  const dict: any = {}
  list.forEach(item => {
    if (item[propName] in dict) {
      // eslint-disable-next-line
      dict[item[propName]]++
    } else {
      dict[item[propName]] = 1
    }
  })
  const res = {
    propName,
  }
  let dupFlag = false
  // eslint-disable-next-line
  for (const dictKey in dict) {
    if (typeof dict[dictKey] === 'number' && dict[dictKey] > 1) {
      // @ts-ignore
      res[dictKey] = dict[dictKey]
      dupFlag = true
    }
  }
  if (dupFlag) {
    // eslint-disable-next-line
    console.table(res)
    console.log(list)
    return res
  } else {
    return false
  }
}

// 金额数字处理，输入数字和单位，输出符号、千分位分隔的整数和小数（不含小数点）
export const toMoneyString = (num: number, unit: 'yuan' | 'fen') => {
  const isPositive = num >= 0
  const numInYuan = unit === 'fen' ? num / 100 : num
  const intPart = Math.trunc(Math.abs(numInYuan)).toLocaleString()
  const decimalPart = numInYuan.toFixed(2).slice(-2)
  return {
    sign: isPositive ? '+' : '-',
    intPart,
    decimalPart,
  }
}
// 2021-01-01 转换2021年1月1日
export const toYearData = (num: string, type?: string): any => {
  if (!num) return ''
  const str = num.toString()
  return `${str.substr(0, 4)}${type || '年'}${str.substr(5, 2).replace(/^0/, '')}${type || '月'}${str.substr(8, 2).replace(/^0/, '')}${type ? '' : '日'}`
}
// 时间戳转换为00:00:00
export const formatTimeToZero = (time: string | number | Date) => new Date(new Date(time).toLocaleDateString()).getTime()
// export const formatDate = (v: any, z = 'YYYY-MM-DD HH:mm:ss') => dayjs(v).format(z)

export function pushHistoryState (data: any, unused: string, url?: string | URL | null): void {
  try {
    const isString = typeof url === 'string'
    if (!isString) return
    // 如果是特殊的 URL, 跳过 pushState 的过程
    if (url.startsWith('http')) {
      window.history.pushState(data, unused, `/m?src=${url}`)
    } else {
      window.history.pushState(data, unused, `/m${url}`)
    }
    return
  } catch (e) {
    console.warn(e)
  }
}

export function getFrameUrl (url?: string | URL | null): string {
  const { pathname: topPathname } = window.top.location
  const isCN = topPathname.startsWith('/cn')
  const isOrderManager = topPathname.startsWith('/order-manager')
  const isString = typeof url === 'string'
  if (!isString) return ''
  let path = ''
  // 如果是特殊的 URL, 跳过 pushState 的过程
  if (url.startsWith('http')) {
    path = isCN || isOrderManager ? `${isCN ? '/cn' : '/order-manager'}/m/web?src=${url}` : `/m/web?src=${url}`
  } else {
    path = isCN || isOrderManager ? `${isCN ? '/cn' : '/order-manager'}/m${url}` : `/m${url}`
  }
  console.log('getFrameUrl', path)
  return path
}

export const getEnv = () => {
  const AWP_DEPLOY_ENV = process.env.AWP_DEPLOY_ENV
  switch (AWP_DEPLOY_ENV) {
    case 'production':
      return 'production'
    case 'staging':
      return 'staging'
    case 'st':
      return 'staging'
    default:
      return 'test'
  }
}

const getMerchantMallSearchParams = () => {
  try {
    const LOGIN_SHOPINFO = JSON.parse(sessionStorage.getItem('LOGIN_SHOPINFO') || '{}')
    const LOGIN_UINFO = JSON.parse(sessionStorage.getItem('LOGIN_UINFO') || '{}')

    const token = getCookie('token')
    const acctId = getCookie('acctId') || LOGIN_UINFO?.acctId || ''
    const wmPoiId = getCookie('shopId') || LOGIN_SHOPINFO?.shopId || 0
    const shopId = wmPoiId
    const region_id = LOGIN_SHOPINFO?.cityId || ''
    const device_uuid = getCookie('device_uuid') || ''
    const bsid = getCookie('bsid') || ''
    const appType = '3'
    const appVersion = '' // ? 和 app 保持一致，写死境内当前最新版本
    const fromPoiChange = 'false'
    const userId = LOGIN_UINFO?.uid || ''

    const searchParams = {
      _source: 'PC',
      token,
      acctId,
      wmPoiId,
      shopId,
      region_id,
      device_uuid,
      bsid,
      appType,
      appVersion,
      fromPoiChange,
      userId,
      biztype: 'keeta',
    }

    return searchParams
  } catch (error) {
    console.log(error)
    return {}
  }
}

const getMerchantMallSearchParamsString = () => {
  const searchParams = getMerchantMallSearchParams()
  return `?${Object.entries(searchParams)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')}`
}

// export const getMerchantMallMenuMap = () => {
//   const origin = MERCHANT_MALL_ORIGIN

//   const searchParams = getMerchantMallSearchParams()

//   console.log('getMerchantMallMenuMap searchParams', searchParams)

//   const hrefMap = {} as MerchantMallHref

//   Object.entries(MERCHANT_MALL_PATH_MAP).forEach(([pageName, href]) => {
//     const url = new URL(origin + href.path)

//     // 添加查询参数
//     Object.entries(searchParams).forEach(([key, value]) => {
//       url.searchParams.set(key, value)
//     })

//     // 处理 hash 部分
//     const hashQueryString = Object.entries(href.hashParams)
//       .map(([key, value]) => `${key}=${value}`)
//       .join('&')

//     url.hash = hashQueryString
//       ? `${href.hash}?${hashQueryString}`
//       : href.hash

//     hrefMap[pageName] = url.href
//   })

//   console.log('MERCHANT_MALL_HREF', hrefMap)

//   return hrefMap
// }

export const getMerchantMallHref = () => {
  // menuMap = {
  //   list: 'https://e.platform.proxy.b.waimai.test.sankuai.com/diagonalley/pc?_source=PC&biztype=keeta&token=0IsaTx3DtHUnFKlFZV1t0ILstLHHSuyIZ_YqnP334rV4*&acctId=111502188&wmPoiId=634927&region_id=&device_uuid=!7ecaffb2-2f74-4fb7-87a5-4238d8734836&bsid=T_Y7UGz7xX_TsMLw-iYjkiXFfaJ-RBWeDhEONRus8IfMYEPpPOomR3okLFvxeAbrH7yfuztxLkuMInL48DCnpw&appType=3&fromPoiChange=false&userId=&topOrigin=http%253A%252F%252Fe.b.waimai.test.sankuai.com#/list?market_level=2',
  //   exclusive: 'https://e.platform.proxy.b.waimai.test.sankuai.com/diagonalley/pc?_source=PC&biztype=keeta&token=0IsaTx3DtHUnFKlFZV1t0ILstLHHSuyIZ_YqnP334rV4*&acctId=111502188&wmPoiId=634927&region_id=&device_uuid=!7ecaffb2-2f74-4fb7-87a5-4238d8734836&bsid=T_Y7UGz7xX_TsMLw-iYjkiXFfaJ-RBWeDhEONRus8IfMYEPpPOomR3okLFvxeAbrH7yfuztxLkuMInL48DCnpw&appType=3&fromPoiChange=false&userId=&topOrigin=http%253A%252F%252Fe.b.waimai.test.sankuai.com#/exclusive?market_level=2',
  //   orderList: 'https://e.platform.proxy.b.waimai.test.sankuai.com/diagonalley/pc?_source=PC&biztype=keeta&token=0IsaTx3DtHUnFKlFZV1t0ILstLHHSuyIZ_YqnP334rV4*&acctId=111502188&wmPoiId=634927&region_id=&device_uuid=!7ecaffb2-2f74-4fb7-87a5-4238d8734836&bsid=T_Y7UGz7xX_TsMLw-iYjkiXFfaJ-RBWeDhEONRus8IfMYEPpPOomR3okLFvxeAbrH7yfuztxLkuMInL48DCnpw&appType=3&fromPoiChange=false&userId=&topOrigin=http%253A%252F%252Fe.b.waimai.test.sankuai.com#/orderList?market_level=2',
  //   couponList: 'https://e.platform.proxy.b.waimai.test.sankuai.com/diagonalley/pc?_source=PC&biztype=keeta&token=0IsaTx3DtHUnFKlFZV1t0ILstLHHSuyIZ_YqnP334rV4*&acctId=111502188&wmPoiId=634927&region_id=&device_uuid=!7ecaffb2-2f74-4fb7-87a5-4238d8734836&bsid=T_Y7UGz7xX_TsMLw-iYjkiXFfaJ-RBWeDhEONRus8IfMYEPpPOomR3okLFvxeAbrH7yfuztxLkuMInL48DCnpw&appType=3&fromPoiChange=false&userId=&topOrigin=http%253A%252F%252Fe.b.waimai.test.sankuai.com#/couponList?market_level=2',
  // }
  const location = window.location || window.top.location
  const { href, search } = location
  const t = new URL(href)
  if (!search) {
    t.search = getMerchantMallSearchParamsString()
  }
  t.pathname = MERCHANT_MALL_MENU_PATH_PREFIX
  return t.href
}

export const inMerchantMallPage = () => {
  const { pathname } = window.top.location
  const inMerchantMallPage = pathname.includes(MERCHANT_MALL_MENU_PATH_PREFIX)
  console.log('🚭 ｜inMerchantMallPage', inMerchantMallPage)
  return inMerchantMallPage
}

export const getResolutionInfo = () => {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight

  return {
    // 设备像素比 (DPR)
    devicePixelRatio: window.devicePixelRatio || 1,

    // 屏幕物理分辨率 (宽度)
    screenPhysicalWidth: window.screen.width,

    // 屏幕物理分辨率 (高度)
    screenPhysicalHeight: window.screen.height,

    // 视口宽度 (设备独立像素 - DIP 或 CSS 像素)
    viewportWidth,

    // 视口高度 (设备独立像素 - DIP 或 CSS 像素)
    viewportHeight,

    // 可用的屏幕宽度 (不包括任务栏等 UI 元素)
    screenAvailableWidth: window.screen.availWidth,

    // 可用的屏幕高度 (不包括任务栏等 UI 元素)
    screenAvailableHeight: window.screen.availHeight,

    // 视口宽高
    viewportStr: `${viewportWidth} * ${viewportHeight}`,
  }
}

// 判断是否是桌面端windows系统（排除Xbox等非桌面设备）
export function getIsDesktopWindows () {
  const ua = navigator.userAgent.toUpperCase()
  return (ua.includes('WINDOWS') && !ua.includes('XBOX')) || ua.includes('WIN32') || ua.includes('WIN64')
}

// 处理URL参数，如果已有locale和shopId则替换，否则添加
export const handleUrlParams = (url, language, shopId) => {
  // 解析已有参数
  let [base, query = ''] = url.split('?')
  let params = qs.parse(query)
  params.locale = language
  params.shopId = shopId
  return `${base}?${qs.stringify(params)}`
}

/**
 * 在 URL 中添加或更新查询参数
 * @param {string} url - 原始 URL
 * @param {Object} params - 要添加/更新的查询参数对象
 * @returns {string} 修改后的完整 URL
 */
export function addQueryParams (url: string, params: Record<string, string | string[]>) {
  // 创建 URL 对象解析原始 URL
  const urlObj = new URL(url)

  // 获取当前查询参数
  const searchParams = urlObj.searchParams

  // 添加/更新参数
  Object.entries(params).forEach(([key, value]: [string, string | string[]]) => {
    // 处理数组参数（如：?color=red&color=blue）
    if (Array.isArray(value)) {
      // 先删除所有同名参数
      searchParams.delete(key)
      // 添加数组中的每个值
      value.forEach(v => searchParams.append(key, v))
    } else {
      // 设置单个值
      searchParams.set(key, value as string)
    }
  })

  // 返回完整 URL（保留 hash 部分）
  return urlObj.toString()
}

/**
 * 客服场景页面配置对象
 * 根据位置与CSIMSceneEnum枚举关系表配置
 * @see https://km.sankuai.com/collabpage/2722135336
 */
export const CSPageObj = [
  {
    /** 商家管理后台/接单系统(PC或windows)默认 */
    url: [],
    type: CSIMSceneEnum.HOME,
  },
  {
    /** 商家管理后台首页 */
    url: ['/web/app/home'],
    type: CSIMSceneEnum.MERCHANT_OVERVIEW,
  },
  {
    /** 商家运营分析 */
    url: ['/web/app/bizdata'],
    type: CSIMSceneEnum.MERCHANT_OPERATION_ANALYSIS,
  },
  {
    /** 商家健康度 */
    url: ['/web/mach/b_app_shop_health_score'],
    type: CSIMSceneEnum.MERCHANT_HEALTH_RATING,
  },
  {
    /** 商家订单管理 */
    url: ['/web/mach/b_pc_order'],
    type: CSIMSceneEnum.MERCHANT_ORDER,
  },
  {
    /** 商家订单管理 */
    url: ['/web/mach/b_pc_order'],
    type: CSIMSceneEnum.MERCHANT_ORDER,
  },
  {
    /** 商家财务管理 */
    url: ['/web/app/finance'],
    type: CSIMSceneEnum.MERCHANT_FINANCIAL,
  },
  {
    /** 商家顾客管理 */
    url: ['/web/app/shop#/evaluate'],
    type: CSIMSceneEnum.MERCHANT_CUSTOMER_REVIEWS,
  },
  {
    /** 商家广告管理 */
    url: ['/web/ad/main'],
    type: CSIMSceneEnum.MERCHANT_ADVERTISING,
  },
  {
    /** 商家营销中心 */
    url: ['/web/marketing', '/web/b_marketingv2/#/platformAct'],
    type: CSIMSceneEnum.MERCHANT_PROMOTION_CENTER,
  },
  {
    /** 商家运营设置 */
    url: ['/web/app/shop#/shopSettings', '/web/shop#/subAccountList', '/web/shop#/allShoplist',
      '/web/opcenter/scm#/merchant/delivery', '/web/app/shop#/paymentConfig'],
    type: CSIMSceneEnum.MERCHANT_OPERATION_SETTING,
  },
]
// 禁止登录账号类型
export const ENTER_SOURCE = {
  AgentOperatingAccount: 330, // 代运营主账号
  MerchantOperatingAccount: 331, // 商家运营账号
}
